import React from 'react'
import { Div } from '@sendoutcards/quantum-design-ui'
import { upsaleBannerGraphic } from '../images/upsaleBannerGraphic'

export const PromptingsUpsaleBanner = (props: { onClick?: () => void }) => {
  return (
    <Div
      width="100%"
      height="120px"
      backgroundRepeat="no-repeat"
      backgroundSize="contain"
      backgroundImage={upsaleBannerGraphic}
      onClick={props.onClick}
      cursor="pointer"
    />
  )
}
